module.exports = __webpack_public_path__ + "img/3.bad4f205.jpg";